<template>
    <div class="stat-card" :class="{ 'stat-card--expandable': expandable, 'stat-card--expanded': expandable && expanded }">
        <button-tooltip v-if="expandable" bottom
            :tooltip="expanded ? $t('statistics.collapse') : $t('statistics.expand')">
            <template #activator="{ on, attrs }">
                <button v-on="on" v-bind="attrs" type="button" class="stat-card-expander"
                    @click="$emit('toggle:expand')">
                    <v-icon size="13">{{ expanded ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}</v-icon>
                </button>
            </template>
        </button-tooltip>
        <div v-if="$slots.header" class="stat-card-hdr">
            <slot name="header" />
        </div>
        <div class="stat-card-body" :class="{ 'stat-card-body--flush': flush }">
            <slot />
        </div>
    </div>
</template>

<script>
import ButtonTooltip from '../common/ButtonTooltip.vue'

export default {
    name: 'StatCard',
    components: { ButtonTooltip },
    props: {
        flush: {
            type: Boolean,
            default: false,
        },
        expandable: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>
.stat-card {
    position: relative;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
    transition: border-color 0.3s, box-shadow 0.3s;
}

.stat-card--expanded {
    border-color: rgba(204, 255, 51, 0.28);
    box-shadow: 0 0 28px rgba(204, 255, 51, 0.05), inset 0 0 0 1px rgba(204, 255, 51, 0.07);
}

.stat-card-expander {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 3;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 1px solid var(--v-outline-base);
    border-radius: 6px;
    background: var(--v-surface2-base);
    color: var(--v-txtMuted-base);
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s, color 0.15s, border-color 0.15s, background 0.15s;
}

.stat-card:hover .stat-card-expander {
    opacity: 1;
}

.stat-card--expanded .stat-card-expander {
    opacity: 1;
    color: var(--v-primary-base);
    border-color: rgba(204, 255, 51, 0.45);
    background: rgba(204, 255, 51, 0.09);
}

.stat-card-expander .v-icon {
    color: inherit !important;
}

.stat-card-hdr {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    height: 46px;
    flex-shrink: 0;
    padding: 6px 12px;
    border-bottom: 1px solid var(--v-outline-base);
    background: var(--v-bg-base);
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--v-txtMuted-base);
}

.stat-card--expandable .stat-card-hdr {
    padding-right: 36px;
}

.stat-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 12px 14px;
    min-height: 0;
    overflow: hidden;
}

.stat-card-body--flush {
    padding: 0;
}

@media (max-width: 900px) {
    .stat-card-expander {
        display: none;
    }
}
</style>
